import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import UprightLogo from '@upright/ui/common/generic/components/icons/logo/logo-platform-short.svg';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useIsFullMaintenanceMode } from '../../../../../views/root/context/use-is-maintenance-mode';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { isDmaUser } from '@upright/common/utils';
import { BouColor } from '../../../global/bou-colors';
import { HEADER_HEIGHT_PX } from '../../../layout/layout-constants';
import { fluidSpaceLg } from '../../../utilities/fluid/fluid';
import { BurgerMenu } from './burger-menu';
import { ExploreMenu } from './explore-menu';
import { WorkspaceDropdown } from '@upright/ui/views/shared/workspace-dropdown';

export function MobileHeader() {
  const isFullMaintenance = useIsFullMaintenanceMode();
  const loggedInUser = useGetLoggedInUser();
  const isDmaWorkspaceUser = isDmaUser(loggedInUser);
  const showSearch = !isFullMaintenance;
  const showBurgerMenu = !isFullMaintenance;

  return (
    <Root>
      <Main>
        <Item>
          <Link data-testid={E2eTestElementId.MOBILE_LOGO} to="/">
            <UprightLogo style={{ width: 100, color: 'white' }} />
          </Link>
        </Item>
        {isDmaWorkspaceUser && <WorkspaceDropdown variant="dark" />}
        <Right>
          {showSearch && (
            <Item>
              <ExploreMenu />
            </Item>
          )}
          {showBurgerMenu && (
            <Item>
              <BurgerMenu />
            </Item>
          )}
        </Right>
      </Main>
    </Root>
  );
}

const Root = styled.div`
  position: fixed;
  top: 0;
  height: ${HEADER_HEIGHT_PX};
  width: 100vw;
  z-index: 100;
  background-color: ${BouColor.PLATFORM_BG_BLACK};
  color: ${BouColor.PLATFORM_TEXT_WHITE};
`;

const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
`;

// const MobileLogo = styled.img`
//   width: 200px;
//   max-width: 100%;
//   padding: 0;
//   margin: 0;
// `;

const Right = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1em;
`;

const Item = styled.div`
  & + & {
    ${fluidSpaceLg('margin-left', 50)}
  }
`;
